const danhSachQuanLyLoai = state => state.danhSachQuanLyLoai;
const danhSachQuanLyNguon = state => state.danhSachQuanLyNguon;
const danhSachQuanLyThongBao = state => state.danhSachQuanLyThongBao;
const loaiThongBao = state => state.loaiThongBao;
const lichSuThaoTac = state => state.lichSuThaoTac;

export default {
  danhSachQuanLyLoai,
  danhSachQuanLyNguon,
  danhSachQuanLyThongBao,
  loaiThongBao,
  lichSuThaoTac
};
